import React from 'react'
import BoxAtom from '../../@atoms/to_layout/box/box.atom'
import ButtonAtom from '../../@atoms/to_forms/button/button.atom'
import ContactDetailsWrapperAtom from '../../@atoms/to_content/contact_details_wrapper/contact_details_wrapper.atom'
import EditLocationWrapperAtom from '../../@atoms/to_content/edit_location_wrapper/edit_location_wrapper.atom'
import HereMapAtom from '../../@atoms/to_content/map_h/here_map.atom'
import ModalHeaderAtom from '../../@atoms/to_layout/modal_header/modal_header.atom'
import SkeletonAtom from '../../@atoms/to_layout/skeleton/skeleton.atom'
import TypographyAtom from '../../@atoms/to_content/typography/typography.atom'
import useEditLocation from '../../@hooks/use_edit_location'
import PopupComponent from './popup.component'

const EditLocationComponent: React.FC = function () {
  const {
    loading,
    labels,
    address,
    latitude,
    longitude,
    settings,
    setAddressBasedOnGeoCode,
    close,
    popup,
    closePopup,
    closeModal,
    okHandler,
  } = useEditLocation()

  const closeAll = () => {
    closePopup()
    closeModal()
  }

  return (
    <EditLocationWrapperAtom>
      <ModalHeaderAtom>
        <TypographyAtom ahd_type="h6">
          {labels.locationModal.title}
        </TypographyAtom>
      </ModalHeaderAtom>
      <TypographyAtom ahd_type="step">
        {labels.locationModal.description}
      </TypographyAtom>
      <BoxAtom className="map-wrapper">
        <HereMapAtom
          api_key={settings.mapApiKey}
          app_id={settings.mapAppId}
          lat={latitude}
          lng={longitude}
          ap_position="EDIT_LOCATION_SCREEN"
          setAddressBasedOnGeoCode={setAddressBasedOnGeoCode}
        />
      </BoxAtom>
      <ContactDetailsWrapperAtom>
        <BoxAtom className="address-details-wrapper">
          <TypographyAtom ahd_type="fData">
            {address.contactName}
          </TypographyAtom>
          {loading ? (
            <SkeletonAtom ap_type="edit_location_address_skeleton" />
          ) : (
            <>
              <TypographyAtom ahd_type="fData">
                {address.address}
              </TypographyAtom>
              <TypographyAtom ahd_type="fData">
                {address.countryName}.{address.postcode}
              </TypographyAtom>
            </>
          )}
        </BoxAtom>
      </ContactDetailsWrapperAtom>
      <BoxAtom className="button-wrapper">
        <ButtonAtom
          ap_type="secondary"
          fullWidth
          disabled={loading}
          onClick={close}
        >
          {labels.locationModal.buttonCancel}
        </ButtonAtom>
        <ButtonAtom
          ap_type="primary"
          onClick={okHandler}
          fullWidth
          disabled={loading}
        >
          {labels.locationModal.buttonFormSubmit}
        </ButtonAtom>
      </BoxAtom>
      <PopupComponent
        open={popup.open}
        type={popup.type}
        cancelButton={closeAll}
        okButton={closePopup}
      />
    </EditLocationWrapperAtom>
  )
}

export default EditLocationComponent
